module.exports = __webpack_public_path__ + "img/8.bbc9b370.png";